angular.module('FlexyBeautyApp.services')
    .factory('ConstantsCustomerPosts', ['gettextCatalog', function (gettextCatalog) {
        var colorsAvailable = {
            'A' : '#B71C1C',
            'B' : '#880E4F',
            'C' : '#4A148C',
            'D' : '#311B92',
            'E' : '#1A237E',
            'F' : '#0D47A1',
            'G' : '#01579B',
            'H' : '#006064',
            'I' : '#004D40',
            'J' : '#1B5E20',
            'K' : '#33691E',
            'L' : '#827717',
            'M' : '#E65100',
            'N' : '#BF360C',
            'O' : '#B71C1C',
            'P' : '#880E4F',
            'Q' : '#4A148C',
            'R' : '#311B92',
            'S' : '#1A237E',
            'T' : '#0D47A1',
            'U' : '#01579B',
            'V' : '#006064',
            'W' : '#4E342E',
            'X' : '#1B5E20',
            'Y' : '#212121',
            'Z' : '#827717'
        }
        return colorsAvailable;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsCustomerPosts.js